import { useEffect, useState } from 'react';
import { Select, Button, Form, DatePicker, Input, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import DataBreachService from '../../../../../services/DataBreach.service';
import useNotify from '../../../../../context/Notification/useNotify';
import ModalFail from '../../../../../components/Shared/modal/fail';
import ModalSuccess from '../../../../../components/Shared/modal/success';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday'; 
import localeData from 'dayjs/plugin/localeData';
import parse from 'html-react-parser';

export default function Tab4Component({ details, permission, triggerDetails, setTriggerDetails, dataBreachLogDetail, tab4Form, viewMode4, setViewMode4, validateTab4, tab1Result }) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(weekday); 
    dayjs.extend(localeData); 
    const { t, i18n } = useTranslation('data-breach');
    const lang = i18n?.language;
    // const [viewMode, setViewMode] = useState(true);
    const [informing, setInforming] = useState([]);
    const [informingOrigin, setInformingOrigin] = useState([]);

    const [change, setChange] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [loadinSave, setLoadinSave] = useState(false);
    const [isDate1Enabled, setIsDate1Enabled] = useState(false);
    const [isDate2Enabled, setIsDate2Enabled] = useState(false);
    const [isDate3Enabled, setIsDate3Enabled] = useState(false);
    const [isDate4Enabled, setIsDate4Enabled] = useState(false);
    const [isDate5Enabled, setIsDate5Enabled] = useState(false);
    const [isDate7Enabled, setIsDate7Enabled] = useState(false);
    const [openModalStatus, setOpenModalStatus] = useState(undefined);
    const notify = useNotify();
    const [postFlag, setPostFlag] = useState(false);
    const [isShowNotion, setIsShowNotion] = useState(true);



    const handleSelectChange = (value, fieldName, setDateEnabled) => {
        const isEnabled = (value === 1 || value === 8 || value === 9);
        setDateEnabled(isEnabled);

        if (!isEnabled) {
            tab4Form.setFields([
                {
                    name: fieldName,
                    errors: [],
                }
            ])
            tab4Form.resetFields([fieldName]);
        }
    };

    const resetError = (value) => {
        tab4Form.setFields([
            {
                name: value,
                errors: [],
            }
        ])
    };
    const clearForm = () => {
        tab4Form.resetFields();
    };
    useEffect(() => {
        getInformingDetail();
    }, [details]);

    const prepareInformingData = (informingList) => {
        const formatDate = (dateString) => {
            if (!dateString) return null;
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('en-GB', {
                timeZone: 'Asia/Bangkok',
            }).format(date);
        };

        const data = {};
        informingList.forEach((item) => {
            data[`sequence${item.sequence}`] = lang === 'en' ? `${item.answerEn ? item.answerEn : '-'}  ${item.notifyDate ? '- Date of notification ' + formatDate(item.notifyDate) : ''}` : `${item.answerTh ? item.answerTh : '-'} ${item.notifyDate ? '- วันที่ที่แจ้งให้ทราบ ' + formatDate(item.notifyDate) : ''}`;
        });
        return data;
    };

    const findIdByNameEn = (nameEn) => {
        const result = answerMap.find(item => item.nameEn === nameEn);
        return result ? result.id : null;
    };

    const getInformingDetail = async (trigger = false) => {
        try {
            const { data } = await DataBreachService.getInformingDetail(details);
            if (data?.resultData) {
                const informing = prepareInformingData(data?.resultData);
                setInforming(informing);
                if (trigger) {
                    setPostFlag(false);
                } else {
                    await setViewMode4(true);
                    setForm(data?.resultData);
                }
                setInformingOrigin(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }

    };


    const setForm = async (data) => {
        const initialValues = {};
        data.forEach((item) => {
            const sequence = item.sequence;
            const notifyDate = item.notifyDate ? dayjs(item.notifyDate).tz('Asia/Bangkok') : null;
            initialValues[`question${item.sequence}Answer`] = sequence === 6 ? item.answerEn : findIdByNameEn(item.answerEn);
            initialValues[`question${sequence}Date`] = notifyDate;

            if (notifyDate) {
                const setDateEnabled = eval(`setIsDate${sequence}Enabled`);
                if (setDateEnabled) setDateEnabled(true);
            }
        });
        tab4Form.setFieldsValue(initialValues);
    };

    useEffect(() => {
        validateTab4 && tab4Form.validateFields();
    }, [validateTab4]);

    const answerMap = [
        {
            id: 1,
            nameEn: 'Yes',
            nameTh: 'ใช่'
        },
        {
            id: 2,
            nameEn: 'We are in the process of informing them',
            nameTh: 'เรากำลังดำเนินการแจ้งให้พวกเขาทราบ'
        },
        {
            id: 3,
            nameEn: 'No, not applicable',
            nameTh: 'ไม่ พวกเขาไม่เกี่ยวข้อง'
        },
        {
            id: 4,
            nameEn: 'No, they are already aware',
            nameTh: 'ไม่ พวกเขารับทราบแล้ว'
        },
        {
            id: 5,
            nameEn: 'No, but we are planning to',
            nameTh: 'ไม่ แต่เรากำลังวางแผนจะแจ้งให้ทราบ'
        },
        {
            id: 6,
            nameEn: 'No, we have decided not to',
            nameTh: 'ไม่ เราได้ตัดสินใจแล้วว่าจะไม่แจ้งให้ทราบ'
        },
        {
            id: 7,
            nameEn: 'We have not yet decided if we need to',
            nameTh: 'เรายังไม่ได้ตัดสินใจว่าจำเป็นต้องแจ้งให้ทราบหรือไม่'
        },
        {
            id: 8,
            nameEn: 'Yes, we have informed them directly.',
            nameTh: 'ใช่ เราได้แจ้งให้พวกเขาทราบโดยตรง'
        },
        {
            id: 9,
            nameEn: 'Yes, we have informed them via a public notice.',
            nameTh: 'ใช่ เราได้แจ้งให้พวกเขาทราบผ่านประกาศสาธารณะ'
        },
        {
            id: 10,
            nameEn: 'We consider that this incident meets the threshold to report.',
            nameTh: 'เราถือว่าเหตุการณ์นี้เข้าข่ายต้องรายงาน'
        },
        {
            id: 11,
            nameEn: 'We do not consider that this incident meets the threshold to report, but wanted to make the supervisory authority aware.',
            nameTh: 'เราไม่ถือว่าเหตุการณ์นี้เข้าข่ายต้องรายงาน แต่ต้องการให้หน่วยงานกำกับดูแลได้รับทราบ'
        },
        {
            id: 12,
            nameEn: 'We are unclear whether this incident meets the threshold to report.',
            nameTh: 'เราไม่แน่ใจว่าเหตุการณ์นี้เข้าข่ายต้องรายงานหรือไม่'
        },
        {
            id: 13,
            nameEn: 'We choose to generate a Data Breach Report from the WhiteFact',
            nameTh: 'เราเลือกสร้างรายงาน Data Breach Report จากระบบ WhiteFact'
        },
        {
            id: 14,
            nameEn: 'We have created one manually',
            nameTh: 'เราสร้างรายงานดังกล่าวด้วยตนเองไว้แล้ว'
        },
        {
            id: 15,
            nameEn: 'We are planning to',
            nameTh: 'เรากำลังวางแผนจะทำ'
        },
        {
            id: 16,
            nameEn: 'We have decided not to',
            nameTh: 'เราตัดสินใจแล้วว่าจะไม่ทำ'
        },
        {
            id: 17,
            nameEn: 'We have not yet decided if we need to',
            nameTh: 'เรายังไม่ได้ตัดสินใจว่าจำเป็นต้องทำหรือไม่'
        },
    ]
    const q1Options = [
        answerMap[0],
        answerMap[1],
        answerMap[2],
        answerMap[3],
        answerMap[4],
        answerMap[5],
        answerMap[6],
    ]

    const q2Options = [
        answerMap[0],
        answerMap[1],
        answerMap[4],
        answerMap[5],
        answerMap[6],
    ]

    const q3Options = [
        answerMap[7],
        answerMap[8],
        answerMap[9],
        answerMap[1],
        answerMap[3],
        answerMap[4],
        answerMap[5],
        answerMap[6],
    ]

    const q4Options = [
        answerMap[0],
        answerMap[1],
        answerMap[4],
        answerMap[5],
        answerMap[6],
    ]
    const q5Options = [
        answerMap[9],
        answerMap[10],
        answerMap[11],
    ]
    const q6Options = [
        answerMap[12],
        answerMap[13],
        answerMap[14],
        answerMap[15],
        answerMap[16],

    ]

    const handleEdit = () => {
        setViewMode4(false)
        setForm(informingOrigin);
    };
    const checkValidate = (values) => {
        const questions = [
            { answerField: 'question1Answer', dateField: 'question1Date' },
            { answerField: 'question2Answer', dateField: 'question2Date' },
            { answerField: 'question3Answer', dateField: 'question3Date' },
            { answerField: 'question4Answer', dateField: 'question4Date' },
            { answerField: 'question7Answer', dateField: 'question7Date' },

        ];

        questions.forEach(({ answerField, dateField }) => {
            if (values[answerField] === 1) {
                if (!values[dateField]) {
                    tab4Form.setFields([
                        {
                            name: dateField,
                            errors: [t('requiredField')],
                        },
                    ]);
                } else {
                    tab4Form.setFields([
                        {
                            name: dateField,
                            errors: [],
                        },
                    ]);
                }
            } else {
                tab4Form.setFields([
                    {
                        name: dateField,
                        errors: [],
                    },
                ]);
            }
        });

        if (values.question5Answer === 8 || values.question5Answer === 9) {
            !values.question5Date ? tab4Form.setFields([
                {
                    name: 'question5Date',
                    errors: [t('requiredField')],
                },
            ]) : tab4Form.setFields([
                {
                    name: 'question5Date',
                    errors: [],
                },
            ]);
        }
    };

    const transformSubmissionToInformingList = (submissionObject) => {
        const informingList = [];

        Object.entries(submissionObject).forEach(([key, value]) => {
            const match = key.match(/^question(\d+)(Answer|Date)$/);
            if (match) {
                const sequence = parseInt(match[1], 10);
                const type = match[2];

                let entry = informingList.find((item) => item.sequence === sequence);

                if (!entry) {
                    const informingData = informingOrigin.find((item) => item.sequence === sequence);
                    entry = {
                        // informingId: informingData ? informingData.informingId : null, // Assign informingId
                        sequence,
                        answerEn: null,
                        answerTh: null,
                        notifyDate: null,
                    };
                    if (informingOrigin.length > 0) {
                        entry.informingId = informingData.informingId
                    }
                    informingList.push(entry);
                }

                if (type === 'Answer') {
                    const answer = answerMap.find((item) => item.id === value);
                    if (answer) {
                        entry.answerEn = answer.nameEn;
                        entry.answerTh = answer.nameTh;
                    } else {
                        entry.answerEn = value;
                        entry.answerTh = value;
                    }
                } else if (type === 'Date') {
                    entry.notifyDate = Date.parse(value) || null;
                }
            }
        });

        return informingList;
    };

    const onFinish = async (values) => {
        try {
            checkValidate(values);

            await tab4Form.validateFields(); // Ensure validation is done properly

            const errors = tab4Form.getFieldsError().filter(({ errors }) => errors.length > 0);

            if (errors.length > 0) {
                const firstErrorField = errors[0].name[0]; // Get the first field with an error
                tab4Form.scrollToField(firstErrorField, {
                    behavior: "smooth",
                    block: "center",
                });
                return; // Stop execution if errors exist
            }
            
            setLoadinSave(true);
            const informingList = transformSubmissionToInformingList(values);
            const payload = {
                txnDataBreachId: details,
                informingList: informingList,
                isReport: tab4Form.getFieldValue('question7Answer') === 1 ? true : false
                // outcome: tab2Form.getFieldValue('question303') === 24 ? 3 : tab2Form.getFieldValue('question303')

            }
            if (Object.keys(informing).length !== 0) {
                DataBreachService.updateInforming(payload)
                    .then((res) => {
                        if (res.data.resultMsg === 'SUCCESS') {
                            setOpenModalStatus(true);
                        } else {
                            setOpenModalStatus(false);
                        }
                        setTriggerDetails(!triggerDetails);
                        setPostFlag(true);
                        getInformingDetail();
                        setLoadinSave(false);
                        setViewMode4(false)
                    })
                    .catch((err) => {
                        notify({
                            type: 'error',
                            title: t('Fail'),
                            description: t('FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                        setLoadinSave(false);
                    });
            } else {
                DataBreachService.saveInforming(payload)
                    .then((res) => {
                        if (res.data.resultMsg === 'SUCCESS') {
                            setOpenModalStatus(true);
                        } else {
                            setOpenModalStatus(false);
                        }
                        setTriggerDetails(!triggerDetails);
                        setPostFlag(true);
                        getInformingDetail(true)
                        setLoadinSave(false);
                    })
                    .catch((err) => {
                        setLoadinSave(false);
                        notify({
                            type: 'error',
                            title: t('Fail'),
                            description: t('FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                    });
            }
            setEditFlag(false);
        }
        catch (error) {
            console.error('Validation failed:', error);
            setLoadinSave(false); // Ensure loading state resets
        }

    };
    const closeNotion = () => {
        setIsShowNotion(false);
    };
    return (
        <>
            <div>
                {tab1Result.length > 0 && isShowNotion && (
                    <div className='bg-[#FFF0F6] rounded'>
                        <div className="py-2.5 px-5 ">
                            <div className='flex justify-between'>
                                <p className='mb-0 text-base font-bold text=[#171717]'>{t('From your assessment of the violation, here is our advice for you')}</p>
                                <svg className='cursor-pointer' onClick={() => closeNotion()} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_1522_141236)">
                                        <g clip-path="url(#clip1_1522_141236)">
                                            <path d="M18.3569 1.64258L1.64258 18.3569M1.64258 1.64258L18.3569 18.3569" stroke="#65707A" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1522_141236">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                        <clipPath id="clip1_1522_141236">
                                            <rect width="18" height="18" fill="white" transform="translate(1 1)" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                            <p className="mb-0 font-semibold text-base">
                                {lang === 'en'
                                    ? tab1Result[0]?.question?.en
                                    : tab1Result[0]?.question?.th}
                            </p>
                            {lang === 'en'
                                ? parse(tab1Result[0]?.text?.en)
                                : parse(tab1Result[0]?.text?.th)}
                        </div>
                    </div>
                )}
                <h5 className='pt-3 text-base font-semibold'>{t('Informing Other Parties')}</h5>
                {viewMode4 ?
                    <>
                        <div className='py-3'>
                            <p className='mb-0 text-sm font-semibold'>
                                1. {t('Have you reported the incident to the data processor')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence1 || '-'}
                            </p>
                        </div>
                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        <div className='py-3'>
                            <p className='mb-0 text-sm	font-semibold'>
                                2. {t('Have you reported the incident to your DPO')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence2 || '-'}
                            </p>
                        </div>
                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        <div className='py-3'>
                            <p className='mb-0 text-sm	font-semibold'>
                                3. {t('Have you reported the incident to the top executive of the company')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence3 || '-'}
                            </p>
                        </div>
                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        <div className='py-3'>
                            <p className='mb-0 text-sm	font-semibold'>
                                4. {t('Have you reported this to the police or not')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence4 || '-'}
                            </p>
                        </div>
                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        <div className='py-3'>
                            <p className='mb-0 text-sm	font-semibold'>
                                5. {t('Have you reported the incident to the Data Subject')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence5 || '-'}
                            </p>
                            <p className='mb-0 text-sm	font-semibold pt-4'>
                                {t('Please add any additional information that you believe is necessary regarding informing the data subject')}
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence6 || '-'}
                            </p>
                        </div>
                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        <div className='py-3'>
                            <p className='mb-0 text-sm	font-semibold'>
                                6. {t('Have you reported the incident to the PDPC')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence7 || '-'}
                            </p>
                            <p className='mb-0 text-sm	font-semibold pt-4'>
                                {t('What is the reason for this report')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence8 || '-'}
                            </p>
                            <p className='mb-0 text-sm	font-semibold pt-4'>
                                {t('Have you provided a report to PDPC')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <p className='mb-0 text-sm	font-normal pt-2'>
                                {informing?.sequence9 || '-'}
                            </p>
                        </div>
                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        <div className='flex justify-end pt-4 stick-bottom'>
                            {
                                !permission.viewOnly && dataBreachLogDetail.statusEn !== 'New' &&
                                dataBreachLogDetail.statusEn !== 'Resolved' &&
                                dataBreachLogDetail.statusEn !== 'Reject' && <Button
                                    onClick={() => handleEdit()}
                                    type='primary'
                                    size='large'
                                    className='w-36'
                                    htmlType='button'
                                    disabled={!permission.viewEdit || dataBreachLogDetail.statusEn === 'New'}>
                                    {t('Edit')}
                                </Button>
                            }

                        </div>
                    </>
                    :
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        onFinish={onFinish}
                        form={tab4Form}
                        className="w-full"
                        layout="vertical"
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                    >

                        <div className='pt-4'>
                            <p className='mb-0 text-sm	font-semibold'>
                                1. {t('Have you reported the incident to the data processor')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <div className='mb-0 text-sm font-normal pt-2 flex gap-2'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Specify the date of notification')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question1Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        onChange={(value) =>
                                            handleSelectChange(value, 'question1Date', setIsDate1Enabled)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q1Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span className="text-sm font-normal">
                                                {t('Specify the date of notification')}
                                            </span>
                                            <span className={`${!isDate1Enabled && 'hidden'} text-error`}>*</span>
                                        </>
                                    }
                                    name="question1Date"
                                    className='self-end'
                                >
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        size="large"
                                        format="DD/MM/YYYY"
                                        onChange={(value) => {
                                            resetError('question1Date')
                                        }}
                                        disabled={!isDate1Enabled}
                                        placeholder='DD/MM/YYYY'
                                        allowClear={false}
                                    />
                                </Form.Item>
                            </div>
                            <hr className='border-b border-solid border-[#ECECEC]'></hr>
                        </div>
                        <div className='pt-4'>
                            <p className='mb-0 text-sm	font-semibold'>
                                2. {t('Have you reported the incident to your DPO')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <div className='mb-0 text-sm font-normal pt-2 flex gap-2'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Specify the date of notification')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question2Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        onChange={(value) =>
                                            handleSelectChange(value, 'question2Date', setIsDate2Enabled)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q2Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span className="text-sm font-normal">
                                                {t('Specify the date of notification')}
                                            </span>
                                            <span className={`${!isDate2Enabled && 'hidden'} text-error`}>*</span>
                                        </>
                                    }
                                    name="question2Date"
                                    className='self-end'
                                >
                                    <DatePicker
                                        allowClear={false}
                                        style={{ width: '100%' }}
                                        size="large"
                                        format="DD/MM/YYYY"
                                        onChange={(value) => {
                                            resetError('question2Date')
                                        }}
                                        disabled={!isDate2Enabled}
                                        placeholder='DD/MM/YYYY'
                                    />
                                </Form.Item>
                            </div>
                            <hr className='border-b border-solid border-[#ECECEC]'></hr>


                        </div>
                        <div className='pt-4'>
                            <p className='mb-0 text-sm	font-semibold'>
                                3. {t('Have you reported the incident to the top executive of the company')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <div className='mb-0 text-sm font-normal pt-2 flex gap-2'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Specify the date of notification')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question3Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        onChange={(value) =>
                                            handleSelectChange(value, 'question3Date', setIsDate3Enabled)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q2Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span className="text-sm font-normal">
                                                {t('Specify the date of notification')}
                                            </span>
                                            <span className={`${!isDate3Enabled && 'hidden'} text-error`}>*</span>
                                        </>
                                    }
                                    name="question3Date"
                                    className='self-end'
                                >
                                    <DatePicker
                                        allowClear={false}
                                        style={{ width: '100%' }}
                                        size="large"
                                        format="DD/MM/YYYY"
                                        onChange={(value) => {
                                            resetError('question3Date')
                                        }}
                                        disabled={!isDate3Enabled}
                                        placeholder='DD/MM/YYYY'
                                    />
                                </Form.Item>
                            </div>
                            <hr className='border-b border-solid border-[#ECECEC]'></hr>


                        </div>
                        <div className='pt-4'>
                            <p className='mb-0 text-sm	font-semibold'>
                                4. {t('Have you reported this to the police or not')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <div className='mb-0 text-sm font-normal pt-2 flex gap-2'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Specify the date of notification')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question4Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        onChange={(value) =>
                                            handleSelectChange(value, 'question4Date', setIsDate4Enabled)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q2Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span className="text-sm font-normal">
                                                {t('Specify the date of notification')}
                                            </span>
                                            <span className={`${!isDate4Enabled && 'hidden'} text-error`}>*</span>
                                        </>
                                    }
                                    name="question4Date"
                                    className='self-end'
                                >
                                    <DatePicker
                                        allowClear={false}
                                        style={{ width: '100%' }}
                                        size="large"
                                        format="DD/MM/YYYY"
                                        onChange={(value) => {
                                            resetError('question4Date')
                                        }}
                                        disabled={!isDate4Enabled}
                                        placeholder='DD/MM/YYYY'
                                    />
                                </Form.Item>
                            </div>
                            <hr className='border-b border-solid border-[#ECECEC]'></hr>


                        </div>
                        <div className='pt-4'>
                            <p className='mb-0 text-sm	font-semibold'>
                                5. {t('Have you reported the incident to the Data Subject')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <div className='mb-0 text-sm font-normal pt-2 flex gap-2'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Specify the date of notification')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question5Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        onChange={(value) =>
                                            handleSelectChange(value, 'question5Date', setIsDate5Enabled)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q3Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span className="text-sm font-semibold">
                                                {t('Specify the date of notification')}
                                            </span>
                                            <span className={`${!isDate5Enabled && 'hidden'} text-error`}>*</span>
                                        </>
                                    }
                                    name="question5Date"
                                    className='self-end'
                                >
                                    <DatePicker
                                        allowClear={false}
                                        style={{ width: '100%' }}
                                        size="large"
                                        format="DD/MM/YYYY"
                                        onChange={(value) => {
                                            resetError('question5Date')
                                        }}
                                        disabled={!isDate5Enabled}
                                        placeholder='DD/MM/YYYY'
                                    />
                                </Form.Item>
                            </div>
                            <div className='mb-0 text-sm font-normal pt-2 flex'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Please add any additional information that you believe is necessary regarding informing the data subject')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question6Answer"
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder={t('Please specify information')}
                                        maxLength={1000}
                                        showCount
                                        rows={3}
                                    />
                                </Form.Item>
                            </div>
                            <hr className='border-b border-solid border-[#ECECEC]'></hr>


                        </div>
                        <div className='pt-4'>
                            <p className='mb-0 text-sm	font-semibold'>
                                6. {t('Have you reported the incident to the PDPC')}
                                <span className='text-error pl-2'>*</span>
                            </p>
                            <div className='mb-0 text-sm font-normal pt-2 flex gap-2'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Specify the date of notification')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question7Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        onChange={(value) =>
                                            handleSelectChange(value, 'question7Date', setIsDate7Enabled)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q4Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span className="text-sm font-semibold">
                                                {t('Specify the date of notification')}
                                            </span>
                                            <span className={`${!isDate7Enabled && 'hidden'} text-error`}>*</span>
                                        </>
                                    }
                                    name="question7Date"
                                    className='self-end'
                                >
                                    <DatePicker
                                        allowClear={false}
                                        size="large"
                                        style={{ width: '100%' }}
                                        placeholder="DD/MM/YYYY"
                                        format="DD/MM/YYYY"
                                        onChange={(value) => {
                                            resetError('question7Date')
                                        }}
                                        disabled={!isDate7Enabled}
                                    />


                                </Form.Item>
                            </div>
                            <div className='mb-0 text-sm font-normal pt-2 flex'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('What is the reason for this report')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question8Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        size="large"
                                        placeholder={t('Please select an option')}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {q5Options.map((item) => (
                                            <Select.Option
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {lang === 'en' ? item.nameEn : item.nameTh}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className='mb-0 text-sm font-normal pt-2 flex'>
                                <Form.Item
                                    label={
                                        <span className="text-sm font-semibold">
                                            {t('Have you provided a report to PDPC')}
                                        </span>
                                    }
                                    className='w-full'
                                    name="question9Answer"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'requiredField'
                                            ),
                                        },
                                    ]}
                                >

                                    <Radio.Group
                                        className="w-full"
                                    >
                                        {q6Options.map((is) => {
                                            return (

                                                <div key={is.id}>
                                                    <Radio
                                                        value={is.id}
                                                        style={{ lineHeight: '32px' }}
                                                    >
                                                        {lang === 'en' ? is.nameEn : is.nameTh}
                                                    </Radio>
                                                </div>
                                            );
                                        })}

                                    </Radio.Group>
                                </Form.Item>
                            </div>

                            <hr className='border-b border-solid border-[#ECECEC]'></hr>


                        </div>
                        <div className='flex justify-end pt-4 stick-bottom'>
                            <Button
                                size="large"
                                type="default"
                                className="text-purple-PHX border-purple-PHX w-full"
                                onClick={() => clearForm()}
                                style={{
                                    width: 'fit-content',
                                    marginRight: 10,
                                }}
                            >
                                {t('Clear')}
                            </Button>
                            <Button
                                loading={loadinSave}
                                size="large"
                                htmlType="submit"
                                type="primary"
                                className="w-full"
                                style={{ width: 120 }}
                            >
                                {t('Save')}
                            </Button>
                        </div>
                    </Form>
                }

            </div>
            {openModalStatus && (
                <ModalSuccess
                    open={openModalStatus}
                    handelClose={() => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        setViewMode4(true);
                    }}
                    handelOk={() => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        setViewMode4(true);
                    }}
                    text={t('Successfully saved data')}
                />
            )}
            <ModalFail
                open={openModalStatus === false}
                handelClose={() => {
                    setOpenModalStatus(undefined);
                }}
                handelOk={() => {
                    setOpenModalStatus(undefined);
                }}
                text={t('Failed to submit data')}
            />
        </>
    );
}
